import { Input, Spinner } from '@barfacil/barfacil-ui'
import { Search } from 'lucide-react'
import { useRef, useState } from 'react'

import { PriceListParams } from '@/api/_schemas/management'
import { cn } from '@/lib/utils'

type PriceListFilterSearchProps = React.HTMLAttributes<HTMLDivElement> & {
  setFilters: React.Dispatch<React.SetStateAction<PriceListParams>>
  isFetching: boolean
}

export const PriceListFilterSearch = ({
  setFilters,
  isFetching,
  className,
  ...rest
}: PriceListFilterSearchProps) => {
  const [searchText, setSearchText] = useState('')

  const debounceSearch = useRef<number>(0)

  function handleSearchTextChange(event: React.ChangeEvent<HTMLInputElement>) {
    window.clearInterval(debounceSearch.current)

    const { value } = event.currentTarget

    setSearchText(value)

    debounceSearch.current = window.setTimeout(() => {
      return setFilters({
        search: value || undefined,
      })
    }, 550)
  }

  return (
    <div className={cn('relative flex flex-1', className)} {...rest}>
      <Search className="absolute left-2 top-3 shrink-0 opacity-50" size={16} />

      <Input
        className={cn('flex h-10 pl-8', isFetching && 'pr-8')}
        value={searchText}
        onChange={handleSearchTextChange}
        placeholder="Pesquisar"
        type="search"
        readOnly={isFetching}
      />

      {isFetching && (
        <Spinner className="absolute right-2 top-3 size-4 shrink-0" />
      )}
    </div>
  )
}
